import React, { lazy } from "react";
import { FormattedMessage } from "react-intl";
import { EntityBadgeListFragment$key } from "./__generated__/EntityBadgeListFragment.graphql";
import {
  ResponsiveModal,
  ResponsiveModalCloseDrawer,
  ResponsiveModalContent,
  ResponsiveModalDescription,
  ResponsiveModalTitle,
  ResponsiveModalTrigger,
} from "@/kit/ui/responsive-modal";
import { Button } from "@/kit/ui/button";
import { Award03Icon } from "@/icons";
import Suspense from "@/common/Suspense";

const EntityBadgeAwardForm = lazy(() => import("./EntityBadgeAwardForm"));

export interface EntityBadgeAwardButtonProps {
  entity: EntityBadgeListFragment$key;
  onAwarded?: () => void;
}

export function EntityBadgeAwardButton(props: EntityBadgeAwardButtonProps) {
  const [dialogOpen, setDialogOpen] = React.useState(false);

  return (
    <ResponsiveModal open={dialogOpen} onOpenChange={setDialogOpen}>
      <ResponsiveModalTrigger asChild>
        <Button variant="primary">
          <FormattedMessage defaultMessage="Award badge" />
          <Award03Icon className="w-5 h-5" />
        </Button>
      </ResponsiveModalTrigger>
      <ResponsiveModalContent
        className="lg:w-[720px] bg-linear-to-b from-brand-25 from-[-16.39%] to-white to-[65.62%]"
        onCloseAutoFocus={(event) => event.preventDefault()}
        onOpenAutoFocus={(event) => event.preventDefault()}
      >
        <div className="flex flex-col px-2 gap-1">
          <ResponsiveModalTitle>
            <FormattedMessage defaultMessage="Award a badge" />
          </ResponsiveModalTitle>
          <ResponsiveModalDescription>
            <FormattedMessage defaultMessage="Select a badge and award it." />
          </ResponsiveModalDescription>
        </div>
        <div className="flex flex-col px-2 gap-3 mt-2">
          <Suspense>
            <EntityBadgeAwardForm
              entity={props.entity}
              onSubmit={() => {
                setDialogOpen(false);
                props.onAwarded?.();
              }}
            />
          </Suspense>
          <ResponsiveModalCloseDrawer asChild>
            <Button variant="secondary">
              <FormattedMessage defaultMessage="Close" />
            </Button>
          </ResponsiveModalCloseDrawer>
        </div>
      </ResponsiveModalContent>
    </ResponsiveModal>
  );
}
